"use client"

import { useContext, useState } from "react"
import { MyContext } from "../../../context/MyContext"
import { postData } from "../../../services/NodeServices"
import { toast } from "react-toastify"
import { Edit2, Save, User, Mail, Phone } from "lucide-react"

export default function ProfileInfo() {
  const [isEditingName, setIsEditingName] = useState(false)
  const [isEditingMobileno, setIsEditingMobileNo] = useState(false)
  const [isEditingEmail, setIsEditingEmail] = useState(false)
  const { user } = useContext(MyContext)

  const inituser = JSON.parse(localStorage.getItem("user"))

  const [firstname, setFirstName] = useState(inituser?.firstname)
  const [lastName, setLastName] = useState(inituser?.lastname)
  const [gender, setGender] = useState(inituser?.gender)
  const [mobile, setMobile] = useState(inituser?.mobile)
  const [email, setEmail] = useState(inituser?.email)

  const handleApplyChanges = async () => {
    try {
      const result = await postData("api/users/updateuser", {
        mobile,
        firstname,
        lastname: lastName,
        gender,
        userid: inituser.userid,
      })

      if (result.status) {
        toast.success("Changes applied Successfully")
        const token = inituser.token
        const newdata = result.data
        newdata["token"] = token
        localStorage.setItem("user", JSON.stringify(newdata))
      }

      setIsEditingName(false)
      setIsEditingMobileNo(false)
      setIsEditingEmail(false)
    } catch (error) {
      toast.error("Failed to update profile")
    }
  }

  const handelApplygeder = async (selectedGender) => {
    setGender(selectedGender)
    try {
      const result = await postData("api/users/updateuser", {
        mobile,
        firstname,
        lastname: lastName,
        gender: selectedGender,
        userid: inituser.userid,
      })

      if (result.status) {
        toast.success("Gender updated successfully")
        const token = inituser.token
        const newdata = result.data
        newdata["token"] = token
        localStorage.setItem("user", JSON.stringify(newdata))
      }
    } catch (error) {
      toast.error("Failed to update gender")
    }
  }

  return (
    <div className="max-w-2xl mx-auto p-4 bg-white">
      {user && (
        <div className="bg-white p-4 mb-4">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-2">
              <User className="w-4 h-4 text-orange-600" />
              <h2 className="text-sm font-medium text-gray-900">Personal Information</h2>
            </div>
            <button
              onClick={() => setIsEditingName(!isEditingName)}
              className="flex items-center space-x-1 px-2 py-1 text-orange-600 hover:bg-orange-50 rounded text-xs"
            >
              <Edit2 className="w-3 h-3" />
              <span>Edit</span>
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">First Name</label>
              <input
                type="text"
                value={firstname}
                onChange={(e) => setFirstName(e.target.value)}
                disabled={!isEditingName}
                className={`w-full px-2 py-2 text-sm rounded border ${
                  isEditingName ? "border-orange-300 focus:border-orange-500" : "border-gray-200 bg-gray-50"
                } focus:outline-none`}
              />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">Last Name</label>
              <input
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                disabled={!isEditingName}
                className={`w-full px-2 py-2 text-sm rounded border ${
                  isEditingName ? "border-orange-300 focus:border-orange-500" : "border-gray-200 bg-gray-50"
                } focus:outline-none`}
              />
            </div>
          </div>

          <div className="mb-4">
            <label className="block text-xs font-medium text-gray-700 mb-2">Gender</label>
            <div className="flex space-x-2">
              <button
                onClick={() => handelApplygeder("Male")}
                className={`px-3 py-1 text-xs rounded ${
                  gender === "Male" ? "bg-orange-500 text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                }`}
              >
                Male
              </button>
              <button
                onClick={() => handelApplygeder("Female")}
                className={`px-3 py-1 text-xs rounded ${
                  gender === "Female" ? "bg-orange-500 text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                }`}
              >
                Female
              </button>
            </div>
          </div>

          {isEditingName && (
            <div className="flex justify-end">
              <button
                onClick={handleApplyChanges}
                className="flex items-center space-x-1 px-3 py-1 bg-black text-white text-xs rounded hover:bg-gray-800"
              >
                <Save className="w-3 h-3" />
                <span>Apply</span>
              </button>
            </div>
          )}
        </div>
      )}

      <div className="bg-white p-4 mb-4">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center space-x-2">
            <Phone className="w-4 h-4 text-orange-600" />
            <h3 className="text-sm font-medium text-gray-900">Mobile Number</h3>
          </div>
          <button
            onClick={() => setIsEditingMobileNo(!isEditingMobileno)}
            className="flex items-center space-x-1 px-2 py-1 text-orange-600 hover:bg-orange-50 rounded text-xs"
          >
            <Edit2 className="w-3 h-3" />
            <span>Edit</span>
          </button>
        </div>

        <div>
          <input
            type="tel"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            disabled={!isEditingMobileno}
            className={`w-full px-2 py-2 text-sm rounded border ${
              isEditingMobileno ? "border-orange-300 focus:border-orange-500" : "border-gray-200 bg-gray-50"
            } focus:outline-none`}
          />
        </div>
      </div>

      <div className="bg-white p-4">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center space-x-2">
            <Mail className="w-4 h-4 text-orange-600" />
            <h3 className="text-sm font-medium text-gray-900">Email Address</h3>
          </div>
          <button
            onClick={() => setIsEditingEmail(!isEditingEmail)}
            className="flex items-center space-x-1 px-2 py-1 text-orange-600 hover:bg-orange-50 rounded text-xs"
          >
            <Edit2 className="w-3 h-3" />
            <span>Edit</span>
          </button>
        </div>

        <div>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={!isEditingEmail}
            className={`w-full px-2 py-2 text-sm rounded border ${
              isEditingEmail ? "border-orange-300 focus:border-orange-500" : "border-gray-200 bg-gray-50"
            } focus:outline-none`}
          />
        </div>

        {(isEditingMobileno || isEditingEmail) && (
          <div className="flex justify-end mt-3">
            <button
              onClick={handleApplyChanges}
              className="flex items-center space-x-1 px-3 py-1 bg-black text-white text-xs rounded hover:bg-gray-800"
            >
              <Save className="w-3 h-3" />
              <span>Apply</span>
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
